// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multi-select-dropdown {
    position: relative;
    width: 250px;
  }
.multi-select-dropdown.custom-width {
    position: relative;
    width: 100%;
  }
  
  .select-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px;
    border: 1px solid #E0E3E8;
    background: #fff;
    cursor: pointer;
    border-radius: 8px;
  }
  .arrow {
    padding: 0 4px;
  }
  .select-body {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    border: 1px solid #ddd;
    background: #fff;
    border-radius: 4px;
    height: max-content;
    max-height: 300px;
    overflow-y: auto;
    z-index: 1000;
  }
  
  .search-input {
    width: 100%;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin-bottom: 10px;
  }
  
  .options {
    height: 100%;
    max-height: 240px;
    overflow-y: auto;
  }
  
  .option {
    display: flex;
    align-items: center;
    gap: .5rem;
    padding: 10px;
    cursor: pointer;
  }
  
  .option:hover {
    background-color: #f0f0f0;
    color: #0d47a0;
  }
  
  .option.selected {
    background-color: #F4F4F4;
    color: #121314;
  }
  
  .no-options {
    padding: 10px;
    color: #aaa;
  }
  .selected-items {
    display: flex;
    padding: .1rem .25rem;
    border: 1px solid #e4e5e6;
    border-radius: 1rem;
    gap:.25rem;
  }
  .selection-container {
    display: flex;
    flex-wrap: wrap;
    gap: .5rem;
    overflow: auto;
    height: 34px;
    align-items: center;
    font-family: 'poppins', sans-serif;
  }

  @media screen and (max-width:1199px) {
    .multi-select-dropdown {
      position: relative;
      width: 100%;
      max-width: 250px;
      min-width: 200px;
    }
  }
  @media screen and (max-width:767px) {
    .multi-select-dropdown {
      position: relative;
      width: 46%;
      max-width: 100%;
      min-width: 120px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/MultiSelectDropdown/MultiSelectDropdown.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;EACd;AACF;IACI,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,aAAa;IACb,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,aAAa;IACb,eAAe;IACf,UAAU;IACV,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,kCAAkC;EACpC;;EAEA;IACE;MACE,kBAAkB;MAClB,WAAW;MACX,gBAAgB;MAChB,gBAAgB;IAClB;EACF;EACA;IACE;MACE,kBAAkB;MAClB,UAAU;MACV,eAAe;MACf,gBAAgB;IAClB;EACF","sourcesContent":[".multi-select-dropdown {\r\n    position: relative;\r\n    width: 250px;\r\n  }\r\n.multi-select-dropdown.custom-width {\r\n    position: relative;\r\n    width: 100%;\r\n  }\r\n  \r\n  .select-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 6px;\r\n    border: 1px solid #E0E3E8;\r\n    background: #fff;\r\n    cursor: pointer;\r\n    border-radius: 8px;\r\n  }\r\n  .arrow {\r\n    padding: 0 4px;\r\n  }\r\n  .select-body {\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 0;\r\n    right: 0;\r\n    border: 1px solid #ddd;\r\n    background: #fff;\r\n    border-radius: 4px;\r\n    height: max-content;\r\n    max-height: 300px;\r\n    overflow-y: auto;\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .search-input {\r\n    width: 100%;\r\n    padding: 8px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    margin-bottom: 10px;\r\n  }\r\n  \r\n  .options {\r\n    height: 100%;\r\n    max-height: 240px;\r\n    overflow-y: auto;\r\n  }\r\n  \r\n  .option {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: .5rem;\r\n    padding: 10px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .option:hover {\r\n    background-color: #f0f0f0;\r\n    color: #0d47a0;\r\n  }\r\n  \r\n  .option.selected {\r\n    background-color: #F4F4F4;\r\n    color: #121314;\r\n  }\r\n  \r\n  .no-options {\r\n    padding: 10px;\r\n    color: #aaa;\r\n  }\r\n  .selected-items {\r\n    display: flex;\r\n    padding: .1rem .25rem;\r\n    border: 1px solid #e4e5e6;\r\n    border-radius: 1rem;\r\n    gap:.25rem;\r\n  }\r\n  .selection-container {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: .5rem;\r\n    overflow: auto;\r\n    height: 34px;\r\n    align-items: center;\r\n    font-family: 'poppins', sans-serif;\r\n  }\r\n\r\n  @media screen and (max-width:1199px) {\r\n    .multi-select-dropdown {\r\n      position: relative;\r\n      width: 100%;\r\n      max-width: 250px;\r\n      min-width: 200px;\r\n    }\r\n  }\r\n  @media screen and (max-width:767px) {\r\n    .multi-select-dropdown {\r\n      position: relative;\r\n      width: 46%;\r\n      max-width: 100%;\r\n      min-width: 120px;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
